import { Component, Input, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'app-logo-header',
  templateUrl: './logo-header.component.html',
  styleUrls: ['./logo-header.component.scss'],
})
export class LogoHeaderComponent implements OnInit {
  public languages = ['ar', 'en'];
  public currentLanguages: string = "en";
  public authenticated: boolean = false;
  public isSeller: boolean = false;
  @Input() buyerPages: boolean = false;
  @Input() publicPayment : boolean = false;

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    @Inject(PLATFORM_ID) private platformID: any
  ) {
    if (isPlatformBrowser(this.platformID)) {
      if (localStorage.getItem('language')) {
        this.changeLanguage(localStorage.getItem('language'));
      } else {
        this.changeLanguage('en');
      }
    }
  }

  async ngOnInit(): Promise<void> {

    if (isPlatformBrowser(this.platformID)) {
      this.authenticated = this.authService.isAuthenticated();
      if (this.authenticated) {
        if (await this.authService.isSellerOrisAdmin('Seller')) {
          this.isSeller = true;
        } else if (await this.authService.isSellerOrisAdmin('Admin')) {
          this.isSeller = false;
        }
      }
    }
  }

  changeLanguage(language: string): void {
    this.translate.use(language);
    localStorage.setItem('language', language);
    this.currentLanguages = language;

    if (language === 'ar') {
      document.body.classList.add('dir-rtl');
      return;
    }
    document.body.classList.remove('dir-rtl');
  }
}
